// src/app/meter/components/meter-analytics/meter-top-consumers/meter-top-consumers.component.ts

import { Component, Input } from '@angular/core';
import { TopConsumer } from '../../../models/meter-analytics.model';

@Component({
    selector: 'app-meter-top-consumers',
    templateUrl: './meter-top-consumers.component.html',
    styleUrls: ['./meter-top-consumers.component.scss'],
})
export class MeterTopConsumersComponent {
    @Input() data: TopConsumer[] = [];

    displayedColumns: string[] = ['rank', 'nodeId', 'street', 'totalConsumption'];
}
